import React from 'react'
import { NumberPad } from '@/components/NumberPad'
import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'
import { useGetWallet, type WalletCurrency } from '@/domain'

export const TransferOutNumberPad: React.FC = () => {
  // Store state - используем тот же подход что и в withdraw/first-deposit
  const isFiatMode = useSavingsStore((s) => s.goalTransferOut.isFiatMode)
  const fiatAmount = useSavingsStore((s) => s.goalTransferOut.fiatAmount)
  const cryptoAmount = useSavingsStore((s) => s.goalTransferOut.cryptoAmount)
  const setGoalTransferOut = useSavingsStore((s) => s.setGoalTransferOut)

  const user = useUserStore((s) => s.user)
  const wallet = useUserStore((s) => s.wallet)
  const displayCurrency = wallet?.displayCurrency || 'USD'

  // Получаем данные кошелька для USDT
  const { data: walletData } = useGetWallet()
  const completeCurrencies = useUserStore((s) => s.wallet?.completeCurrencies)

  // Находим USDT в кошельке пользователя
  const usdtWallet = completeCurrencies?.find(
    (currency: WalletCurrency) => currency.code === 'USDT',
  )

  // Функции для обновления сумм - прямые, как в withdraw
  const setFiatAmount = (amount: { amount: string; code: string }) => {
    setGoalTransferOut({
      fiatAmount: amount,
    })
  }

  const setCryptoAmount = (amount: { amount: string; code: string }) => {
    setGoalTransferOut({
      cryptoAmount: amount,
    })
  }

  // Создаем объект selectedCurrency с правильной структурой
  const selectedCurrency = {
    code: 'USDT',
    pricePerUnit: usdtWallet?.pricePerUnit || 1.0, // Используем реальный курс из кошелька
  }

  // Функция тряски - store автоматически сбросит triggerShake через 600ms
  const shakeComponent = () => {
    setGoalTransferOut({ triggerShake: true })
  }

  return (
    <NumberPad
      isFiatMode={isFiatMode}
      fiatAmount={fiatAmount}
      cryptoAmount={cryptoAmount}
      setFiatAmount={setFiatAmount}
      setCryptoAmount={setCryptoAmount}
      selectedCurrency={selectedCurrency}
      shakeComponent={shakeComponent}
      maxLength={12}
    />
  )
}
